<!--
2021-11-25 CHP 修稿BonusPerc，从服务端获取
-->
<template>
  <div class="accountPage" v-if="mounted">
    <div class="tabList">
      <div
        class="tab pointer"
        :class="{'tabSelected': $store.state.currentRoute === item.key}"
        v-for="(item, index) in tabList"
        :key="index"
        @click="selectTab(item.key)">
        {{tabCase(item)}}
      </div>
    </div>
    <div class="tabContainer">
      <div class="account" v-if="$store.state.currentRoute === 'Setting/Account'">
        <div class="row">
          <div class="caption">
            {{$t('lang.account.totalBalance')}}
          </div>
          <div class="inputRow">
            <div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Cash + this.accountInfo.Gift + this.accountInfo.WithdrawableCash)}}</div>
          </div>
        </div>
        <div class="row">
          <div class="caption">
            {{$t('lang.account.cash')}}
          </div>
          <div class="inputRow">
            <div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Cash + this.accountInfo.Gift)}}</div>
          </div>
        </div>
        <div class="row">
          <div class="caption">
            <div>{{$t('lang.account.withdrawableBalance')}}</div>
          </div>
          <div class="inputRow">
            <div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.WithdrawableCash)}}</div>
            <div class="depositBtn pointer" @click="selectTab('Setting/Deposit')">{{$t('lang.account.deposit')}}</div>
            <div class="withdrawBtn pointer" @click="selectTab('Setting/Withdraw')">{{$t('lang.account.withdraw')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="caption">
            {{$t('lang.account.invite')}}
          </div>
          <div class="linkRow">
            <label>
              <input type="text" readonly ref="link" :value="this.accountInfo.InviteLink">
            </label>
            <div class="copy pointer" @click="copy">{{$t('lang.account.copy')}}</div>
          </div>
        </div>
      </div>
      <div class="deposit" v-if="$store.state.currentRoute === 'Setting/Deposit'">
        <div class="row">
          <div class="inputRow" v-for="(item, index) in selectedGateway.DepositRange" :key="index" v-if="gatewayListByType.length > 0 && selectedGateway.Name != 'CoinsPay'">
            <div
              class="amount pointer"
              v-for="(amount, indx) in item"
              :key="index + '_' + indx"
              :class="{'selected': amount === depositAmount}"
              v-if="fetchRange(amount, 'deposit')"
              @click="fetchAmount(amount, 'deposit', index, indx)"
            >
              <div
                :class="changeDepositRangeBg(index)"
                v-if="selectedGateway.DepositDiscountRange && selectedGateway.DepositDiscountRange[index] && selectedGateway.DepositDiscountRange[index][indx]"
              >
                +{{ selectedGateway.DepositDiscountRange[index][indx] }}
              </div>
              <div v-else class="discountRange" style="background: none;"></div>
              <span>
                  {{separateThousandInteger(amount)}}
                </span>
            </div>
          </div>
          <div class="gatewayRow" style="margin-top: 20px" >
            <div class="gatewayItem" v-for="(item, index) in gatewayList" :key="index">
              <div>
                <input type="radio" style="height: 25px" :value="item" v-model="selectedGateway" @click="fetchTransaction(item)"/>
                <img :src="require('@/assets/images/common/'+item.GatewayType+'.png')"
                     class="upiLogo" @click="fetchTransaction(item)"/>
              </div>
              <div>
                <span style="font-size: 12px; color: #FFFFFF;cursor: pointer" @click="fetchTransaction(item)">Gateway #{{index+1}}</span>
              </div>
            </div>
          </div>
          <div class="checkRow">
<!--            <div v-if="bonusPercentage > 0">
              <label>
                <input type="checkbox" v-model="bonusCheck">
              </label>
              <span>{{$t('lang.account.apply')}}</span><span style="margin-left: 5px; margin-right: 5px">{{bonusPercentage}}%</span><span>{{$t('lang.account.depositBonus')}}</span>
            </div>-->
            <div>
              <label>
                <input type="checkbox" v-model="agreeCheck">
              </label>
              {{$t('lang.account.agree')}}
            </div>
          </div>
        </div>
        <div>
          <div class="submit pointer" @click="handleDeposit">{{$t('lang.account.submit')}}</div>
        </div>
      </div>
      <div class="withdraw" v-if="$store.state.currentRoute === 'Setting/Withdraw'">
        <div class="balance-caption">
          <div class="">
            <span>{{$t('lang.account.withdrawableBalance')}}</span>
          </div>
        </div>
        <div class="cashCount">
          <div>
            <span>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.WithdrawableCash > this.accountInfo.cash ? this.accountInfo.cash: this.accountInfo.WithdrawableCash)}}</span>
          </div>
        </div>
        <div
          class="gift-prompt"
          v-if="this.accountInfo.Gift > 0"
          v-html="$t('lang.account.betThenWithdraw', {
            bet: `${fetchCurrency[userInfo.CurrencyName]}${separateThousand(this.accountInfo.BetingToConvertToWithdrawableCash + this.accountInfo.Cash)}`,
            withdraw: `${fetchCurrency[userInfo.CurrencyName]}${separateThousand(this.accountInfo.Gift + this.accountInfo.Cash)}`
          })"
        >
        </div>
        <!--印度版 需要进行身份验证-->
        <div v-if="$store.state.internation == 'IN'">
<!--          <div class="row" style="margin-bottom: 0px">
            <div class="operateRow">
              <div class="label">{{$t('lang.account.yourID')}}</div>
              <img :src="ok" v-if="$store.state.verifyInfo && $store.state.verifyInfo.IDVerfiyStatus == 20">
              <img :src="warn" v-if="$store.state.verifyInfo && $store.state.verifyInfo.IDVerfiyStatus == -10">
              <div class="btn" @click="showVerify('id')">
                <span v-if="!$store.state.verifyInfo || $store.state.verifyInfo.IDVerfiyStatus <= 0">{{$t('lang.account.upload')}}</span>
                <span v-if="$store.state.verifyInfo && $store.state.verifyInfo.IDVerfiyStatus > 0">{{$t('lang.account.view')}}</span>
              </div>
            </div>
          </div>-->
          <div class="row" style="text-align: right; margin-bottom: 0px"
               v-if="$store.state.verifyInfo && $store.state.verifyInfo.IDVerfiyStatus < 20 && $store.state.verifyInfo.AuditMessage">
            <span class="audit-message">{{$store.state.verifyInfo.AuditMessage}}</span>
          </div>
          <div class="row" style="margin-top: 20px; margin-bottom: 0px">
            <div class="operateRow">
              <div class="label">{{$t('lang.account.bankAccount')}}</div>
              <img :src="ok" v-if="$store.state.verifyInfo && $store.state.verifyInfo.BankCardVerifyStatus == 20">
              <img :src="warn" v-if="$store.state.verifyInfo && $store.state.verifyInfo.BankCardVerifyStatus == -10">
              <div class="btn pointer" @click="showVerify('account')">
              <span
                v-if="!$store.state.verifyInfo || !activeBankAccount||(activeBankAccount&&activeBankAccount.BankCardVerifyStatus <= 0)">{{
                  $t('lang.account.set')
                }}</span>
                <span
                  v-if="$store.state.verifyInfo && (activeBankAccount&&activeBankAccount.BankCardVerifyStatus > 0)">{{
                    $t('lang.menu.Account')
                  }} {{
                    (activeBankAccount.Index + 1) * 1
                  }}</span>
              </div>
            </div>
          </div>
          <div class="row" style="text-align: right;"
               v-if="$store.state.verifyInfo && $store.state.verifyInfo.BankCardVerifyStatus < 20 && $store.state.verifyInfo.BankMessage">
            <span class="audit-message">{{$store.state.verifyInfo.BankMessage}}</span>
          </div>
        </div>
        <!--非印度版 不需要进行身份验证-->
        <div class="row" v-if="$store.state.internation != 'IN'"
             v-for="(key, index) in Object.keys(withdrawInfo)" :key="index">
          <div class="caption">
            {{withdrawDict[key]}}
          </div>
          <div class="inputRow">
            <div class="input">
              <label>
                <input type="text" v-model="withdrawInfo[key]">
              </label>
            </div>
          </div>
        </div>
        <div class="caption" style="margin-top: 20px">
          {{$t('lang.account.amount')}}
          <div class="tips">
            {{$t('lang.account.selectAmount')}}
          </div>
        </div>
        <div class="row">
          <div class="inputRow" v-for="(item, index) in withdrawAmountList" :key="index">
            <div
              class="amount pointer"
              v-for="amount in item"
              :key="amount"
              :class="{'selected': amount === withdrawAmount}"
              v-if="fetchRange(amount, 'withdraw')"
              @click="fetchAmount(amount, 'withdraw')"
            >
              {{amount}}
            </div>
          </div>
        </div>
        <div class="tips warning">
          <span @click="onRulesModalClick">
            {{$t('lang.account.withdrawalRules')}}
          </span>
          <Modal
            v-if="isRulesModalShown"
            :isModalShown=isRulesModalShown
            @toggleModalShownStatus="onRulesModalClick"
            :withdrawalRules="withdrawalRules"
          />
        </div>
        <div class="submit" @click="handleWithdraw">{{$t('lang.account.submit')}}</div>
      </div>
      <div class="withdraw" v-if="$store.state.currentRoute === 'Setting/Verify'">
        <Setup :selectTab="selectTab" :tabList=tabList :setupType="withdrawSetup"
               :parentChoose="chooseCard" :handelBack="()=>{this.withdrawSetup=''}" v-if="withdrawSetup" :fetchVerifyInfo="fetchVerifyInfo"/>
      </div>
    </div>
    <form ref="form" :action="GladPayUrl" method="post" v-show="0">
      <input type="hidden" v-for="(key, index) in Object.keys(formData)" :key="index" :name="key" :value="formData[key]">
    </form>
    <ConfirmWin v-if="confirmWinShow"
                :hintText="withdrawConfirmText"
                :okText="$t('lang.account.yesWithdraw')"
                :cancelText="$t('lang.account.noWithdraw')"
                :confirmCancel="closeConfirm"
                :confirmToDo="confirmWithDraw"></ConfirmWin>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {separateThousand, separateThousandInteger} from '@/utils'
import {fetchCurrency} from '@/constant'
import request from '@/service'
import Setup from '@/components/WithdrawSetup/index'
import Modal from '@/components/Modal/index'
import ok from '@/assets/images/common/ok.svg'
import warn from '@/assets/images/common/warn.svg'
import ConfirmWin from '@/components/ConfirmWin/confirmWithTwoButton'

export default {
  name: 'Account',
  data () {
    return {
      activeCardId: -1,
      activeBankAccount: null,
      feeFreeStatus: 0,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showTab: 'Account',
      tabList: [
        {
          label: this.$t('lang.account.wallet'),
          key: 'Setting/Account'
        },
        {
          label: this.$t('lang.account.deposit'),
          key: 'Setting/Deposit'
        },
        {
          label: this.$t('lang.account.withdraw'),
          key: 'Setting/Withdraw'
        }
      ],
      accountInfo: {},
      bonusClaim: '',
      isRulesModalShown: false,
      withdrawalRules: '',
      withdrawAmountList: [[500, 1000, 2000, 5000], [10000, 30000, 50000]],
      withdrawInfo: {
        accountName: '',
        accountNo: '',
        IFSC: ''
      },
      withdrawDict: {
        accountName: this.$t('lang.account.accountName'),
        accountNo: this.$t('lang.account.accountNo'),
        IFSC: this.$t('lang.account.IFSC')
      },
      depositAmount: 0,
      withdrawAmount: 500,
      depositRange: {
        Min: 0,
        Max: 50000
      },
      withdrawRange: {
        Min: 0,
        Max: 50000
      },
      bonusCheck: false,
      agreeCheck: true,
      mounted: false,
      fetchCurrency,
      GladPayUrl: '',
      confirmWinShow: false,
      withdrawConfirmText: '',
      formData: {},
      separateThousand,
      separateThousandInteger,
      gatewayList: [], // v支付网关列表
      gatewayListByType: [],
      selectedGateway: '', // 选择的支付网关,
      userFirstDeposit: false, // 首充
      callBackDeposit: false, // 回归
      membersDayDeposit: false, // 周六会员日
      discountType: 'normal_deposit',
      withdrawSetup: '',
      ok,
      warn,
      bonusType: 'Bonus',
      bonusPercentage: 100, // 2021-11-25 CHP Add
      depositCashBonus: { // 当充值点击充值额度时，计算充值返利和奖金 By HHY 2022-08-16
        amount: 0,
        cash: 0,
        // bonus: 0,
        total: 0
      },
      cashUpPerc: 0 // 充值优惠比例
    }
  },
  components: {
    Setup,
    Modal,
    ConfirmWin
  },
  computed: {
    tabCase () {
      return (item) => {
        return item.label
      }
    },
    fetchRange () {
      return (amount, type) => {
        switch (type) {
          case 'deposit':
            return amount >= this.depositRange.Min && amount <= this.depositRange.Max
          case 'withdraw':
            return amount >= this.withdrawRange.Min && amount <= this.withdrawRange.Max
        }
      }
    }
  },
  mounted () {
    this.fetchAccount()
    this.fetchUserFirstDeposit()
    this.withdrawalRules = this.$t('lang.account.withdrawalRuleList')
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setUserVerifyInfo: 'setUserVerifyInfo',
      setUserBankList: 'setUserBankList'
    }),
    // 2022-11-29 HHY 点击confirm的确认按钮后执行
    confirmWithDraw () {
      const data = {
        userId: this.userInfo.UserId,
        amount: this.withdrawAmount,
        BankAccountId: this.activeBankAccount.Id
      }
      // const url = '/innovation/payments/withdraw2'
      const url = '/innovation/payments/withdraw2/kyc_verification_free'
      request('post', url, data).then(res => {
        let inner = 'lang.withdrawMsg.message' + res.Code
        let msg = this.$t(inner)
        if (res.Code === 6) {
          msg = msg.replace('{amount}', res.Value)
        }
        this.confirmWinShow = false
        this.Toast1(msg)
        this.fetchAccount() // 2021-06-19 CHEN ADD refresh account
      }).catch(err => {
        if (err.status === 400) {
          let inner = 'lang.withdrawMsg.message' + err.data.Code
          let msg = this.$t(inner)
          if (err.data.Code === 6) {
            msg = msg.replace('{amount}', err.data.Value)
          }
          this.Toast(msg)
        }
      })
    },
    Toast (msg) {
      this.$message.error(msg)
    },
    Toast1 (msg) {
      this.$message.success(msg)
    },
    selectTab (key) {
      this.setCurrentRoute(key)
      if (this.$route.name === key) return
      this.$router.push('/' + key)
    },
    fetchUserFirstDeposit () {
      const url = '/innovation/sevendaygift/get-user-info'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, false).then(res => {
        this.userFirstDeposit = !res.IsDeposited
        if (this.userFirstDeposit) {
          this.getGateway()
        } else {
          this.fetchCallBackDeposit()
        }
      })
    },
    fetchCallBackDeposit () {
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      const url = '/innovation/account/callbackcheck'
      const data = {
        userId: userInfo.UserId || '',
        internation: this.$store.state.internation
      }
      request('post', url, data, true).then(res => {
        if (res.CallbackTimeSpan > 0) {
          this.callBackDeposit = true
          this.getGateway()
        } else {
          this.updatedSaturdayMembersDayStatus()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    updatedSaturdayMembersDayStatus () {
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      const url = '/innovation/account/saturdaymembersday'
      const data = {
        userId: userInfo.UserId || ''
      }
      request('post', url, data, false).then(res => {
        if (res.Message) {
          this.membersDayDeposit = true
        } else {
          this.membersDayDeposit = false
        }
        this.getGateway()
      })
    },
    fetchAmount (value, type, index, indx) {
      switch (type) {
        case 'deposit':
          this.depositAmount = value
          this.computeDepositTotal(value, index, indx)
          break
        case 'withdraw':
          this.withdrawAmount = value
          break
      }
    },
    computeDepositTotal (value, index, indx) {
      if (this.selectedGateway.DepositDiscountRange && this.selectedGateway.DepositDiscountRange[index] && this.selectedGateway.DepositDiscountRange[index][indx]) {
        this.depositCashBonus.amount = value

        if (this.userFirstDeposit) {
          this.depositCashBonus.cash = this.selectedGateway.DepositDiscountRange[index][indx] * 1
        } else {
          this.depositCashBonus.cash = value * this.selectedGateway.DepositDiscountRange[index][indx] * 0.01
        }

        this.cashUpPerc = this.selectedGateway.DepositDiscountRange[index][indx]
        this.depositCashBonus.total = this.depositCashBonus.amount + this.depositCashBonus.cash // 移除bonus by HHY 2022-10-29
      } else {
        this.depositCashBonus.amount = value
        this.depositCashBonus.cash = 0
        this.cashUpPerc = 0
        this.depositCashBonus.total = this.depositCashBonus.amount + this.depositCashBonus.cash
      }
    },
    changeDepositRangeBg (index) { // 2022-10-21 HHY 根据行变换充值优惠显示背景
      if (index === 0) {
        return 'discountRange'
      } else if (index === 1) {
        return 'discountRange2'
      } else if (index === 2) {
        return 'discountRange3'
      } else {
        return 'discountRange'
      }
    },
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data).then(res => {
          this.accountInfo = res
        }).catch(err => {
          console.log(err)
        })
      }
    },
    fetchDepositRange () {
      // const url = '/innovation/payments/deposit/getvalidamount'
      // const data = {
      //   userId: this.userInfo.UserId
      // }
      // request('get', url, data).then(res => {
      //   this.mounted = true
      //   this.depositRange = res
      // }).catch(err => {
      //   console.log(err)
      // })
      this.mounted = true
    },
    fetchWithdrawRange () {
      // const url = '/innovation/payments/withdraw/getvalidamount'
      // const data = {
      //   userId: this.userInfo.UserId
      // }
      // request('get', url, data).then(res => {
      //   this.mounted = true
      //   this.withdrawRange = res
      // }).catch(err => {
      //   console.log(err)
      // })
      this.mounted = true
    },
    fetchTransaction (item) {
      this.selectedGateway = item
      this.depositAmount = item.DepositDefultAmount
      this.locateInDepositRangeAndComputeDepositTotal()
    },
    locateInDepositRangeAndComputeDepositTotal () { // 寻找默认充值额度在所有可选充值额度中得索引位置
      var x = -1
      var y = -1
      for (let i = 0; i < this.selectedGateway.DepositRange.length; i++) {
        var range = this.selectedGateway.DepositRange[i]
        for (let j = 0; j < range.length; j++) {
          if (this.selectedGateway.DepositRange[i][j] === this.depositAmount) {
            x = i
            y = j
          }
        }
      }
      this.computeDepositTotal(this.depositAmount, x, y) // 根据索引位置，计算默认充值额度下，用户能得到的最后值（考虑返利、bonus等） by HHY 2022-08-16
    },
    handleDeposit () {
      if (!this.agreeCheck) {
        this.$message.warning(this.$t('lang.account.check'))
        return
      }
      const url = '/innovation/payments/deposit2'
      const data = {
        userId: this.userInfo.UserId,
        amount: this.depositAmount,
        hasBonus: this.bonusCheck,
        apkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0',
        cid: localStorage.getItem('cid'),
        gateway: this.selectedGateway.Name,
        bonusType: this.bonusType, // 2021-11-25 CHP 增加
        internation: this.$store.state.internation, // 2021-11-25 CHP 增加
        cashUpPercentage: this.cashUpPerc, // 2022-08-23 HHY 增加 // 2022-11-11 HHY 暂时没用到后台（后台未接收），目前只是前端显示用
        isFirstDeposit: this.userFirstDeposit, // 2022-11-11 HHY 增加,是否首充，传到后端
        isUserCallback: this.callBackDeposit,
        forCopyVisible: false,
        isSaturdayMembersDay: this.membersDayDeposit,
        discountType: this.discountType
      }
      request('post', url, data).then(res => {
        if (res.Code > 0) {
          // start 2021-07-30 C007 跳转第三方前显示动画
          document.getElementById('loading').style.display = 'block'

          if (res.Code === 1 && res.Url) {
            let newWindow = window.open(res.Url, '_blank')
            this.cancelLoading(newWindow)
          } else {
            this.formData = res.FormField
            this.GladPayUrl = res.Url
            this.$nextTick(() => {
              this.$refs.form.submit()
            })
          }
        } else {
          this.$message.warning(res.Message)
        }
      }).catch(err => {
        // this.$message.error('fail')
        console.log(err)
      })
    },
    cancelLoading (newWindow) {
      if (newWindow.document.body) {
        document.getElementById('loading').style.display = 'none'
      } else {
        setTimeout(this.cancelLoading(newWindow), 500)
      }
    },
    /***
     * 2021-10-31 CHP 根据国家选择不同的提款接口
     */
    handleWithdraw () {
      switch (this.$store.state.internation) {
        case 'IN':
          this.toWithdrawIN()
          break
        case 'INT':
          this.toWithdrawINT()
          break
      }
    },
    /***
     * 国际版提款接口
     * 2021-10-31 CHP 创建
     */
    toWithdrawINT () {
      if (!this.withdrawInfo.accountName) {
        this.$message.error(this.$t('lang.account.withdrawSetup.promptFillAccountName'))
        return
      }
      if (!this.withdrawInfo.accountNo) {
        this.$message.error(this.$t('lang.account.withdrawSetup.promptFillAccountNumber'))
        return
      }
      if (!this.withdrawInfo.IFSC) {
        this.$message.error(this.$t('lang.account.withdrawSetup.promptFillIFSC'))
        return
      }
      if (!this.withdrawAmount) {
        this.$message.error(this.$t('lang.account.selectWithdrawAmount'))
        return
      }

      const url = '/innovation/payments/withdraw'
      const data = {
        userId: this.userInfo.UserId,
        amount: this.withdrawAmount,
        ...this.withdrawInfo
      }
      request('post', url, data).then(res => {
        if (res.status === 400) {
          switch (res.data.Code) {
            case 2:
              this.$message.error(this.$t('lang.account.outRange'))
              break
            case 3:
              this.$message.error(this.$t('lang.account.notEnough'))
              break
          }
        } else {
          this.$message.success(this.$t('lang.common.success'))
        }
      }).catch(err => {
        console.log(err)
        if (err.status === 400) {
          switch (err.data.Code) {
            case 2:
              this.$message.error(this.$t('lang.account.outRange'))
              break
            case 3:
              this.$message.error(this.$t('lang.account.notEnough'))
              break
          }
        }
      })
    },
    closeConfirm () {
      this.confirmWinShow = false
    },
    /***
     * 印度版提款接口
     * 2021-10-31 CHP 创建
     */
    toWithdrawIN () {
      if (this.activeBankAccount && this.activeBankAccount.BankCardVerifyStatus > 0) {
        let url = 'innovation/payments/validatewithdrawnsendhint/kyc_verification_free'
        const data = {
          userId: this.userInfo.UserId,
          amount: this.withdrawAmount,
          BankAccountId: this.activeBankAccount.Id
        }
        request('post', url, data).then(res => {
          let inner = 'lang.withdrawMsg.message' + res.Code
          if (res.Code === 7 || res.Code === 8) { // 2022-11-29 HHY 添加确认确认框
            if (res.Code === 8) {
              this.withdrawConfirmText = this.$t(inner).replace('{amount}', this.$t('lang.account.currencyType') + res.Value)
            } else {
              this.withdrawConfirmText = this.$t(inner)
            }
            this.confirmWinShow = true // 弹出confirm窗
          } else {
            let msg = this.$t(inner)
            if (res.Code === 6) {
              msg = msg.replace('{amount}', res.Value)
            }
            this.$message.success(msg)
          }
        }).catch(err => {
          if (err.status === 400) {
            let inner = 'lang.withdrawMsg.message' + err.data.Code
            let msg = this.$t(inner)
            if (err.data.Code === 6) {
              msg = msg.replace('{amount}', err.data.Value)
            }
            this.$message.error(msg)
          }
        })
      } else {
        this.$message.error(this.$t('lang.account.promptToSubmitBankAccount'))
      }
    },
    copy () {
      this.$refs.link.select()
      document.execCommand('copy')
      this.$message.success(this.$t('lang.account.copySuccess'))
    },
    /**
     * 获取支付网关
     * 2021年10月20日 liubaolong
     */
    getGateway () {
      if (this.userFirstDeposit) { // 首充
        this.discountType = 'first_deposit'
      } else if (this.callBackDeposit) { // 回归 为未活跃7天召回用户
        this.discountType = 'callback_deposit'
      } else if (this.membersDayDeposit) { // 周六会员日
        this.discountType = 'members_day_deposit'
      }
      const url = '/innovation/payments/getavailabledepositgateway2'
      const data = {
        userId: this.userInfo.UserId,
        internation: this.$store.state.internation,
        deposittype: this.discountType
      }
      request('post', url, data).then(res => {
        if (res.Code > 0) {
          this.gatewayList = res.GatewayList
          var counter = 0
          for (var index in this.gatewayList) { // 给每个gateway增加一个序号字段 by HHY 20220611
            counter++
            const gateway = this.gatewayList[index]
            gateway['No'] = counter
          }
          this.gatewayTypes = res.GatewayTypes // by HHY 20220609
          if (this.gatewayTypes.length > 0) {
            this.depositNav = this.gatewayTypes[0].GatewayType
            if (!this.isFromPromotionUpiGuide) {
              this.selectDepositTab(this.depositNav)
            }
            this.isFromPromotionUpiGuide = false // 初始化
          }
        } else {
          this.$message.error(res.Message)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectDepositTab: function (item) { // 选择gatewaytype的tab时触发 by HHY 20220609
      this.depositNav = item
      this.selectGatewaysByType(item)
    },
    selectGatewaysByType: function (item) {
      this.gatewayListByType = []
      for (var index in this.gatewayList) {
        const gateway = this.gatewayList[index]
        if (gateway.GatewayType2 === item) {
          this.gatewayListByType.push(gateway)
        }
      }
      if (this.gatewayListByType.length > 0) {
        this.selectedGateway = this.gatewayListByType[0]
        this.$store.state.bigRparam = JSON.parse(sessionStorage.getItem('BigRconfig'))
        if (this.$store.state.bigRparam && this.$store.state.bigRparam.isBigRuser && this.$store.state.bigRparam.useBigRconfig) { // 如果有大R活动 2022-09-27 HHY
          if (this.selectedGateway.DepositRange[0] !== null && this.selectedGateway.DepositRange[0][0] !== null) {
            this.depositAmount = this.selectedGateway.DepositRange[0][0]
          } else {
            this.depositAmount = 1000
          }
        } else {
          this.depositAmount = this.selectedGateway.DepositDefultAmount
        }
        this.locateInDepositRangeAndComputeDepositTotal()
      }
    },
    showVerify (type) {
      this.setCurrentRoute('Setting/Verify')
      this.withdrawSetup = type
      this.$router.push('/Setting/Verify')
    },
    fetchVerifyInfo () {
      const url = '/innovation/account/getuserverifyinfo'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.setUserVerifyInfo(res.UserVerifyInfo)
        this.setUserBankList(res.BankAccountList)
        const filterList = res.BankAccountList.filter((e) => {
          return e.IsLastUsed === true
        })
        if (filterList.length > 0) {
          this.activeCardId = filterList[0].Id
        }
        if (this.activeCardId === -1 && this.$store.state.bankList && this.$store.state.bankList.length > 0) {
          this.activeCardId = this.$store.state.bankList[0].Id
        }
        this.checkFeeFreeStatus()
        this.chooseCard(this.activeCardId)
      }).catch(err => {
        console.log(err)
      })
    },
    chooseCard (id) {
      let bankList = this.$store.state.bankList
      bankList.forEach((e, i) => {
        e.Index = i
        if (e.Id === id) {
          e.IsLastUsed = true
          this.activeBankAccount = e
        } else {
          e.IsLastUsed = false
        }
      })
      this.setUserBankList(bankList)
    },
    checkFeeFreeStatus () {
      const url = '/innovation/payments/withdrawal/strategy'
      const data = {
        CampaignId: localStorage.getItem('cid'),
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        if (res && res === 'versionA') {
          this.feeFreeStatus = 0
        } else if (res && res === 'versionB') {
          this.feeFreeStatus = 1
        } else if (res && res === 'versionC') {
          this.feeFreeStatus = 2
        } else {
          this.feeFreeStatus = 3
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onRulesModalClick () {
      this.isRulesModalShown = !this.isRulesModalShown
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!localStorage.userInfo) {
        vm.$router.push('/')
      } else {
        vm.userInfo = JSON.parse(localStorage.userInfo)
        if (!vm.depositRange.Min) {
          vm.fetchDepositRange()
        }
        if (!vm.withdrawRange.Min) {
          vm.fetchWithdrawRange()
        }
        if (to.name === 'Withdraw' && from.name !== 'Verify') {
          vm.fetchVerifyInfo(vm)
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
  .accountPage {
    height: 100%;
    display: flex;
    flex-direction: column;
    .tabList {
      width: 60%;
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      .tab {
        font-size: 18px;
        color: #686868;
        flex: 1;
      }
      .tabSelected {
        font-weight: 700;
        color: #F6D9AA;
      }
    }
    .tabContainer {
      flex: 1;
      margin-top: 30px;
      overflow: auto;
      padding: 0 16px 50px;
      .caption {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        margin-bottom: 10px;
        display: flex;
        align-items: flex-end;
        div:first-child {
          margin-right: 115px;
        }
      }
      .row {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .inputRow {
          display: flex;
          &:not(:last-child) {
            margin-bottom: 16px;
          }
          div {
            flex: 3;
            font-size: 16px;
            color: #fff;
            line-height: 40px;
            border-radius: 6px;
            text-align: right;
            padding-right: 15px;
            &:not(:first-child) {
              margin-left: 9px;
            }
            .discountRange {
              position: absolute;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 16px;
              width: 60px;
              min-width: 60px;
              border-radius: 12px 12px 12px 0;
              border:none;
              padding-right: 2px;
              background-color: #ff525a;
            }
            .discountRange2 {
              position: absolute;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 16px;
              width: 60px;
              min-width: 60px;
              border-radius: 12px 12px 12px 0;
              border:none;
              padding-right: 2px;
              background-color: #ff5b39;
            }
            .discountRange3 {
              position: absolute;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 16px;
              width: 60px;
              min-width: 60px;
              border-radius: 12px 12px 12px 0;
              border:none;
              text-align: center;
              padding-right: 2px;
              background-color: #fe1e28;
            }
          }
          .depositBtn, .withdrawBtn {
            flex: 1;
            text-align: center;
            padding: 0;
          }
          .depositBtn {
            background-color: #F6D9AA;
            color: #000;
            border: none;
          }
          .withdrawBtn {
            color: #F6D9AA;
          }
          .amount {
            position: relative;
            //display: flex;
            //justify-content: center;
            border: 1px solid #7D705D;
            color: #7D705D;
            line-height: 48px;
            padding: 0;
            text-align: center;
          }
          .selected {
            font-size: 20px;
            font-weight: 600;
            color: #000;
            background-color: #F6D9AA;
          }
          .claim {
            text-align: center;
            color: #F6D9AA;
            font-size: 18px;
            padding: 0;
          }
        }
        .linkRow {
          display: flex;
          justify-content: space-between;
          label {
            width: 70%;
            input {
              font-size: 14px;
              color: #C4C4C4;
              width: 100%;
            }
          }
          .copy {
            font-size: 14px;
            color: rgba(246, 217, 170, 0.5);
          }
        }
      }
      .deposit {
        .row {
          .gatewayRow{
            display: flex;
            flex-wrap: wrap;
            .gatewayItem{
              /*flex:1*/
              margin-top: 20px;
              margin-right: 54px;
              // &:not(:first-child) {
              //   margin-left: 50px;
              // }
            }
            .upiLogo{
              /*height: 25px;*/
              /*margin-left: 3px;*/
              height: 34px;
              cursor: pointer;
            }

          }
          .checkRow {
            margin-top: 38px;
            margin-bottom: 50px;
            font-size: 12px;
            line-height: 14px;
            color: #fff;
            label {
              height: 14px;
              margin-right: 15px;
              input[type="checkbox"] {
                width: 13px;
                height: 13px;
                line-height: 13px;
                position: relative;
              }
              input[type="checkbox"]::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                background: #fff;
                width: 100%;
                height: 100%;
                border: 1px solid #F6D9AA;
              }
              input[type="checkbox"]:checked::before {
                content: "\2713";
                background-color: #fff;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                color: #7D7D7D;
                font-size: 15px;
                font-weight: bold;
                border: 1px solid #F6D9AA;
              }
            }
            div {
              display: flex;
              align-items: center;
              &:first-child {
                margin-bottom: 15px;
              }
              span {
                color: #F6D9AA;
              }
            }
          }
        }
      }
      .withdraw {
        .tips {
          font-size: 12px;
          line-height: 14px;
          color: #686868;
          margin-left: 10px;
        }
        .warning {
          color: green;
          margin-top: -10px;
          margin-bottom: 30px;
          margin-left: 0;
          cursor: pointer;
          text-decoration: underline;
          text-underline-offset: 2px;
        }
        .row {
          margin-bottom: 20px;
          .inputRow {
            div:not(.input) {
              padding: 0;
              text-align: center;
            }
            input {
              width: 100%;
            }
          }
          .operateRow {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .label {
              font-size: 18px;
              line-height: 21px;
              color: #F6D9AA;
              /*width: calc(100vw - 100px - 30px - 40px);*/
              flex: 1;
            }
            .btn {
              width: 100px;
              font-size: 16px;
              line-height: 30px;
              color: rgba(246, 217, 170, 0.5);
              text-align: center;
              border: 1px solid rgba(246, 217, 170, 0.5);
              border-radius: 6px;
            }

            img{
              width: 25px;
              height: 25px;
              margin-right: 10px;
            }
          }
          .audit-message{
            color: #AA0000;
            font-size: 12px;
            line-height: 14px;
          }
        }
        .cashCount {
          font-size: 40px;
          line-height: 35px;
          color: #fff;
          text-align: center;
          margin-bottom: 20px;
        }
        .balance-caption {
          justify-content: center;
          margin-bottom: 20px;
          font-size: 18px;
          line-height: 21px;
          color: #F6D9AA;
          text-align: center;
        }
        .gift-prompt{
          font-size: 12px;
          line-height: 14px;
          color: #686868;
          margin-bottom: 10px;
          margin-top: 10px;
          text-align: center;
        }
      }
      .submit {
        float: right;
        width: 150px;
        font-size: 22px;
        line-height: 50px;
        color: #000D2E;
        text-align: center;
        background-color: #F6D9AA;
        border-radius: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Account/index.vue